import get from 'lodash/get';
import { VALIDATE_CART_ENDPOINT } from 'bento-ordering/base/constants/endpoints';
import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import {
  VALIDATE_CART_REQUEST,
  VALIDATE_CART_SUCCESS,
  VALIDATE_CART_FAILURE
} from 'bento-ordering/cart/constants/actionTypes';

/*
  validate that selected fulfillment date and time are valid/have not passed,
  that all inventory can be met, and that order min and max can be met
*/

const validateCart = () => (dispatch, getState) => {
  const endpoint = VALIDATE_CART_ENDPOINT;
  const { cart } = getState();
  const currentItems = get(cart, 'items', []);
  if (currentItems.length > 0) {
    return dispatch(
      apiAction(endpoint, 'PUT', [
        VALIDATE_CART_REQUEST,
        VALIDATE_CART_SUCCESS,
        VALIDATE_CART_FAILURE
      ])
    );
  }
};

export default validateCart;
